import { Link } from "react-router-dom";
import { PROJECTS } from "@/data/projects";
import { Section, SectionHeading } from "@/components/shared/Primitives";
import ProjectCard from "@/components/ProjectCard";

export default function Showcase() {
  return (
    <Section id="showcase" testId="showcase-section">
      <div className="flex flex-wrap items-end justify-between gap-8">
        <SectionHeading
          overline="Selected Work"
          title="Selected transmissions from the void."
          lead="Case studies and self-initiated concepts — each one built around a single idea that had to exist."
        />
        <Link
          to="/work"
          data-testid="showcase-all-work-link"
          className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#06B6D4] transition-colors duration-300 hover:text-[#F4F6FB]"
        >
          View all work →
        </Link>
      </div>
      <div className="mt-16 grid gap-8 lg:grid-cols-2 lg:gap-10">
        {PROJECTS.slice(0, 4).map((project, i) => (
          <ProjectCard key={project.slug} project={project} index={i} offset />
        ))}
      </div>
    </Section>
  );
}
